import { Component, Fragment, h, Prop } from '@stencil/core';
import { closeDetails } from '../../redux/actions';
import { store } from '../../redux/store';
import { Unsubscribe } from '@stencil/redux';
import { DetailsMode } from './utils/types';
import { RootState } from '../../redux/reducers';

@Component({
  tag: 'rtr-article-details',
  shadow: false,
})
export class RtrArticleDetails {
  @Prop({ mutable: true }) showDetailsForId: string;
  @Prop({ mutable: true }) showGalleryForId: string;
  @Prop({ mutable: true }) scrollToCalendar: boolean;

  @Prop() mode: DetailsMode = DetailsMode.Search;

  closeDetails!: typeof closeDetails;
  unsubscribe!: Unsubscribe;

  componentWillLoad() {
    this.unsubscribe = store.mapStateToProps(this, (state: RootState) => {
      return {
        showDetailsForId: state.app.showDetailsForId,
        showGalleryForId: state.app.showGalleryForId,
        scrollToCalendar: state.app.showDetailsToCalendar,
      };
    });

    store.mapDispatchToProps(this, {
      closeDetails,
    });
  }

  disconnectedCallback() {
    this.unsubscribe();
  }

  get detailsMode(): DetailsMode {
    if (this.showGalleryForId) {
      return DetailsMode.Gallery;
    }

    return this.mode;
  }

  render() {
    return (
      <Fragment>
        {(!!this.showDetailsForId || !!this.showGalleryForId) && (
          <rtr-article-details-engine
            itemId={this.showDetailsForId || this.showGalleryForId}
            onCloseButtonClick={this.closeDetails}
            mode={this.detailsMode}
            scrollToCalendar={this.scrollToCalendar}
          />
        )}
      </Fragment>
    );
  }
}
